export const BREAKPOINTS = {
  desktop: '1280px',
  mobile: '600px',
  tablet: '960px',
};
